import { combineReducers } from 'redux';
import { connectRouter} from 'connected-react-router';
import { ptoReducer } from './PtoReducers';
import { businessRulesReducers } from './BusinessRulesReducers';

const rootReducer = (history) => combineReducers({
    router: connectRouter(history),
    pto: ptoReducer,
    businessRules: businessRulesReducers,
})

export default rootReducer;